<template>
    <div class="active-filters" v-if="filters && flatFilters && flatFilters.length > 0">
        <span class="clear" v-on:click.prevent="resetSearch()">Clear all filters</span>

        <ul>
            <li v-for="filter in flatFilters" :key="filter.Id" v-on:click.prevent="removeFilter(filter.ParentName, filter.Id)">
                {{filter.Name}}
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        computed: {
            filters: {
                get() {
                    return this.$store.state.search.filters
                },
                set() { }
            },

            flatFilters: function () {
                const vm = this

                if (vm.filters) {
                    const flatFilters = []

                    // var selectedFilters = this.searchFilters.FilterList.Filters.map(x => x.FilterTags)

                    Object.keys(vm.filters).forEach(function (x) {
                        if (x.startsWith('filter_')) {
                            Object.keys(vm.filters[x]).filter(y => y.length > 0).forEach(function (y) {
                                var tag = vm.findFilter(vm.filters[x][y])

                                flatFilters.push({
                                    Id: vm.filters[x][y],
                                    Name: tag ? tag.Name : '',
                                    ParentName: x
                                })
                            })
                        }
                    })

                    return flatFilters
                }

                return null
            }
        },

        methods: {
            findFilter: function (filterId) {
                if (this.searchFilters && this.searchFilters.FilterList && this.searchFilters.FilterList.Filters) {
                    let filter

                    this.searchFilters.FilterList.Filters.find(x => filter = x.FilterTags.find(y => y.Tag.Id == filterId))

                    return filter.Tag
                }

                return null
            },

            removeFilter: function (parent, value) {
                this.$store.dispatch('removeSearchFilter', {
                    parent: parent,
                    value: value
                })

                this.$eventHub.$emit('search-filtersChanged')
            },

            resetSearch: function () {
                this.$store.dispatch('resetSearchFilters')
                this.$store.dispatch('resetSearchResults')
                this.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
                this.$store.dispatch('updateSearchPageCount', 0)
                this.$store.dispatch('updateSearchResultCount', 0)
                this.$store.dispatch('updateSearchResultsLoaded', 0)

                this.$eventHub.$emit('search-filtersChanged')
            }
        },

        props: {
            searchFilters: {
                type: Object
            }
        }
    }
</script>